module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Relatório de Análise\n        "), (!_vm.loading.show) ? _c('span', [(!_vm.somenteLeitura) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gravaRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), (!_vm.somenteLeitura && _vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.calculaRisco($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Calcular Risco")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimirRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Imprimir ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-bottom": "-5px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.closewindow(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Sair e SALVAR")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.closewindow(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Sair SEM SALVAR")])])])])], 1) : _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.proposta.ds_codigo_projeto_erp == null) ? _c('span', {
    staticClass: "alertaCamposPendentes"
  }, [_vm._v(" " + _vm._s(_vm.proposta.ds_codigo_projeto_erp) + "ALERTA: Após o preenchimento da proposta e geração do número de projeto o relatório disponibilizará todos os seus efetivos campos.")]) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Validação',
        href: '/'
      }, {
        text: 'Propostas',
        href: '#'
      }, {
        text: 'Relatório de Análise',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "relatorio_analise"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.proposta.ds_fase !== 'ANALISE'
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('table', {
    staticClass: "w100"
  }, [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "w50"
  }, [_c('h4', {
    staticClass: "titulo ressaltar"
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px !important",
      "font-family": "sans-serif"
    }
  }, [_vm._v("RELATÓRIO DE ANÁLISE")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm._.get(_vm.proposta, 'rating.consultas.PEP', 0) > 0) ? _c('span', [_vm._v("Alçada do Comitê Estratégico")]) : (_vm.ehVoluntariado) ? _c('span', [_vm._v("Alçada do Comitê de Desenvolvimento Social")]) : _c('span', [_vm._v("Alçada do " + _vm._s(_vm.faixaDoProjeto.alcada))])])]), _vm._v(" "), (_vm.proposta.ds_codigo_projeto_erp) ? _c('td', {
    staticClass: "w20"
  }, [_c('h4', {
    staticClass: "ressaltar text-right",
    staticStyle: {
      "font-size": "28px !important",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Projeto nº " + _vm._s(_vm.proposta.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) || _vm.ehPis || _vm.ehVoluntariado) ? _c('div', [_c('div', {
    staticClass: "titulo nao_imprimir alertaCamposPendentes"
  }, [_vm._v("Modelo de Relatório de Análise para projetos " + _vm._s(_vm.ehPIS ? 'do PIS' : (_vm.ehVoluntariado ? 'de Voluntariado' : '')) + " entre " + _vm._s(_vm._f("real")(_vm.faixaDoProjeto.de)) + " à " + _vm._s(_vm._f("real")(_vm.faixaDoProjeto.para)))])]) : _vm._e(), _vm._v(" "), (_vm._.includes([1, 2], _vm.faixaDoProjeto.faixa)) ? _c('div', [_c('div', {
    staticClass: "titulo nao_imprimir alertaCamposPendentes"
  }, [_vm._v("Modelo de Relatório de Análise para projetos até " + _vm._s(_vm._f("real")(_vm.faixaDoProjeto.para)))])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Projetos da Entidade")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.todasPropostas), function(projetos) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(projetos.ds_codigo_projeto_erp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(projetos.ds_nome))]), _vm._v(" "), (projetos.ds_situacao_erp !== null) ? _c('td', {
      staticClass: "situacao_projeto text-center"
    }, [_vm._v(_vm._s(projetos.ds_situacao_erp))]) : _vm._e(), _vm._v(" "), (projetos.ds_situacao_erp === null) ? _c('td', {
      staticClass: "situacao_projeto text-center"
    }, [_vm._v("Não aprovado, fase de\n                            "), (projetos.ds_fase === 'ANALISE') ? _c('span', [_vm._v("Análise")]) : _vm._e(), _vm._v(" "), (projetos.ds_fase === 'DEFERIMENTO') ? _c('span', [_vm._v("Deferimento")]) : _vm._e(), _vm._v(" "), (projetos.ds_fase === 'FORMALIZACAO') ? _c('span', [_vm._v("Formalização")]) : _vm._e()]) : _vm._e()])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])]), _vm._v(" "), (_vm.proposta.nr_projeto_duplicacao) ? _c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Projeto Superior")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.projetoSuperior))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._.has(_vm.proposta, 'ds_fep_tipo_acao') ? (_vm.proposta.ds_fep_tipo_acao === 'AT' ? 'AT - Ação Tática' : (_vm.proposta.ds_fep_tipo_acao === 'AF' ? 'AF - Ação Finalística' : (_vm.proposta.ds_fep_tipo_acao === 'ISD' ? 'ISD - Investimento Social Direto' : 'Ação não informada'))) : 'Ação não informada'))])]), _vm._v(" "), (_vm.proposta) ? _c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Abrangência Nacional")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.proposta.bt_fep_abrangencia === '1' ? 'S - Sim' : 'N - Não'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Período Início e Fim Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ehNulo(_vm.proposta.dt_assinatura_convenio, _vm.proposta.dt_data_inicial), "MM/YYYY")) + "  a  " + _vm._s(_vm.dataFinalProjeto))]), _vm._v(" "), _c('td', [_vm._v("Prazo de execução")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.nr_periodos) + " meses")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('th', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)))])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ressaltar",
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar",
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar",
    staticStyle: {
      "width": "34%"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalParceiro)) + " ")])])]), _vm._v(" "), (_vm.ehVoluntariado || _vm.ehEditalMN) ? _c('tr', [_c('td', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("*A contrapartida corresponde a " + _vm._s(this.$root.formataNumero((_vm.totalContrapartida / _vm.totalFBB), 'percentual')) + "% do valor aportado pela FBB.")])]) : _c('tr', [_c('td', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("*A contrapartida corresponde a " + _vm._s(this.$root.formataNumero((_vm.totalContrapartida / (_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)), 'percentual')) + "% do valor total do projeto.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Entidade Proponente")]), _vm._v(" "), _c('div', [(_vm.proposta.entidade) ? _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [(_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato) && _vm._.has(_vm.proposta.entidade.contato, 'ds_telefone') && !_vm._.isEmpty(_vm.proposta.entidade.contato.ds_telefone)) ? _c('span', [_vm._v(_vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_telefone)) + "  ")]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato) && _vm._.has(_vm.proposta.entidade.contato, 'ds_celular') && !_vm._.isEmpty(_vm.proposta.entidade.contato.ds_celular)) ? _c('span', [_vm._v("celular: " + _vm._s(_vm._f("telefone")(_vm.proposta.entidade.contato.ds_celular)))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Endereço(s)")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [(_vm.proposta.entidade.endereco) ? _c('span', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
    return (endereco.bt_principal === 1) ? _c('p', {
      staticClass: "ressaltar"
    }, [_vm._v("\n                              " + _vm._s(endereco.ds_rua) + ", " + _vm._s(endereco.ds_numero) + ", " + _vm._s(endereco.ds_bairro) + ", " + _vm._s(endereco.ds_complemento) + ", " + _vm._s(endereco.ds_cidade) + " / " + _vm._s(endereco.ds_estado) + ", CEP: " + _vm._s(_vm._f("cep")(endereco.ds_cep)) + "\n                            ")]) : _vm._e()
  }), 0) : _vm._e()])])])]) : _vm._e()])]), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante Legal da Entidade")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered lista"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.dirigentes), function(dirigente) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")) + " até " + _vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.proposta.municipalizacao) ? _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, _vm._l((_vm.municipios = _vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
    return m.ds_municipio + '/' + m.ds_uf
  })), function(municipio, key, index) {
    return _c('span', [_vm._v("\n                              " + _vm._s(municipio[0].ds_municipio + (_vm._.isUndefined(municipio[0].ds_uf) ? '' : '/' + municipio[0].ds_uf) + (index != Object.keys(_vm.municipios).length - 1 ? ',' : '.')) + "\n                            ")])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), (_vm.ehPIS) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Apresentação da entidade proponente")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('apresentacao_entidade')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "name": "ds_problemas"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.apresentacao_entidade),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "apresentacao_entidade", $$v)
      },
      expression: "relatorioAnalise.apresentacao_entidade"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.apresentacao_entidade)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) || _vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Qual(is) problema(s) a proponente quer resolver ?")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_problemas')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "De forma sucinta, descreva a(s) situação(ões)-problema destacada(s) pela proponente.",
      "name": "ds_problemas"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_problemas),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_problemas", $$v)
      },
      expression: "relatorioAnalise.ds_problemas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_problemas)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) || _vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("O que a proponente pretende fazer para solucionar o(s) problema(s) ?")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_solucao_problemas')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "De forma sucinta, descreva o que a instituição propõe executar para solucionar o(s) problema(s) e os gastos previstos.",
      "name": "ds_solucao_problemas"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_solucao_problemas),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_solucao_problemas", $$v)
      },
      expression: "relatorioAnalise.ds_solucao_problemas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_solucao_problemas)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.ehPIS) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" Como a organização pretende operacionalizar as atividades propostas?")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('operacionalizacao_atividades')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "name": "ds_problemas"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.operacionalizacao_atividades),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "operacionalizacao_atividades", $$v)
      },
      expression: "relatorioAnalise.operacionalizacao_atividades"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.operacionalizacao_atividades)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && !_vm.ehVoluntariado) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Quais os resultados esperados por meio da ação proposta ?")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_resultados_esperados')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "De forma sucinta, discorra sobre a efetividade da ação proposta, descrevendo os impactos e transformações esperados no cotidiano dos participantes por meio da implementação do projeto.",
      "name": "ds_resultados_esperados"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_resultados_esperados),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_resultados_esperados", $$v)
      },
      expression: "relatorioAnalise.ds_resultados_esperados"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_resultados_esperados)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && (!_vm.ehPIS && !_vm.ehVoluntariado)) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Principais aspectos positivos da proposta")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_aspectos_positivos')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "De forma sucinta, discorra sobre os principais aspectos positivos da proposta, considerando pontos relacionados à metodologia apresentada pela proponente, ao grau de envolvimento do público participante e ao potencial de continuidade das ações após a execução das atividades (sustentabilidade do projeto).",
      "name": "ds_aspectos_positivos"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_aspectos_positivos),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_aspectos_positivos", $$v)
      },
      expression: "relatorioAnalise.ds_aspectos_positivos"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_aspectos_positivos)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && (!_vm.ehPIS && !_vm.ehVoluntariado)) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Principais preocupações em relação à proposta")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_preocupacoes')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Se for o caso, discorra de forma sucinta sobre os principais aspectos que demandam cuidados em relação à proposta, considerando riscos relacionados às lacunas na metodologia, à qualidade das atividades propostas, aos possíveis impactos ambientais ou sociais negativos, à falta de participação da comunidade, à possível descontinuidade das ações e à ausência de parcerias/acordos com outras instituições.",
      "name": "ds_preocupacoes"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_preocupacoes),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_preocupacoes", $$v)
      },
      expression: "relatorioAnalise.ds_preocupacoes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_preocupacoes)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Análise das condições internas da proponente")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pontos Positivos:")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_condicoes_internas_positivas')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "De forma sucinta, descreva os aspectos positivos sobre o ambiente INTERNO da proponente, destacando pontos como: infraestrutura, capacidade técnica, grau de organização/articulação social, etc.",
      "name": "ds_condicoes_internas_positivas"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_condicoes_internas_positivas),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_internas_positivas", $$v)
      },
      expression: "relatorioAnalise.ds_condicoes_internas_positivas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_internas_positivas)
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Pontos de Atenção:")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_condicoes_internas_negativas')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "De forma sucinta, descreva os aspectos negativos sobre o ambiente INTERNO da proponente, destacando pontos como: infraestrutura, capacidade técnica, grau de organização/articulação social, etc.",
      "name": "ds_condicoes_internas_negativas"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_condicoes_internas_negativas),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_internas_negativas", $$v)
      },
      expression: "relatorioAnalise.ds_condicoes_internas_negativas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_internas_negativas)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Análise das condições externas da proponente")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pontos Positivos:")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_condicoes_externas_positivas')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "De forma sucinta, descreva os aspectos positivos e negativos sobre o ambiente EXTERNO da proponente, destacando pontos como: relacionamento com a gestão pública, mercado local, logística do município, fatores climáticos, stakeholders, etc.",
      "name": "ds_condicoes_externas_positivas"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_condicoes_externas_positivas),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_externas_positivas", $$v)
      },
      expression: "relatorioAnalise.ds_condicoes_externas_positivas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_externas_positivas)
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Pontos de Atenção:")]), _vm._v(" "), _c('div', {
    staticClass: "required",
    class: {
      'has-error': _vm.errors.first('ds_condicoes_externas_negativas')
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "De forma sucinta, descreva os aspectos negativos sobre o ambiente EXTERNO da proponente, destacando pontos como: relacionamento com a gestão pública, mercado local, logística do município, fatores climáticos, stakeholders, etc.",
      "name": "ds_condicoes_externas_negativas"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_condicoes_externas_negativas),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_condicoes_externas_negativas", $$v)
      },
      expression: "relatorioAnalise.ds_condicoes_externas_negativas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_condicoes_externas_negativas)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.publicos_alvo), function(publico) {
    return _c('tr', [(publico.fonte.ds_descricao) ? _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(publico.fonte.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_participantes_diretos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_jovens))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(publico.nr_mulheres))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivos e Metas")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("O objetivo geral da proposta define o que se pretende com a implementação do projeto ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_geral),
      expression: "relatorioAnalise.ds_indicadores_objetivo_geral"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_indicadores_objetivo_geral"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_geral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Os objetivos específicos e as metas do projeto propiciam o atingimento do objetivo geral ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_especifico),
      expression: "relatorioAnalise.ds_indicadores_objetivo_especifico"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_indicadores_objetivo_especifico"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_especifico", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes estatutárias da FBB?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_compativel),
      expression: "relatorioAnalise.ds_indicadores_objetivo_compativel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_indicadores_objetivo_compativel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_compativel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), (!_vm.ehPIS && !_vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes de programa estruturado (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_estruturado),
      expression: "relatorioAnalise.ds_indicadores_objetivo_estruturado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_indicadores_objetivo_estruturado"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_estruturado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.ehPIS || _vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Existe alguma crítica em relação aos objetivos, metas e indicadores apresentados pela proponente?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.existe_critica_objetivos_metas_indicadores),
      expression: "relatorioAnalise.existe_critica_objetivos_metas_indicadores"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "existe_critica_objetivos_metas_indicadores"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "existe_critica_objetivos_metas_indicadores", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), ((_vm._.has(_vm.relatorioAnalise, 'existe_critica_objetivos_metas_indicadores') && _vm.relatorioAnalise.existe_critica_objetivos_metas_indicadores === 'Sim')) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "name": "critica_objetivos_metas_indicadores"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.critica_objetivos_metas_indicadores),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "critica_objetivos_metas_indicadores", $$v)
      },
      expression: "relatorioAnalise.critica_objetivos_metas_indicadores"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.critica_objetivos_metas_indicadores)
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.ehPIS && !_vm.ehVoluntariado) ? _c('tr', [_c('td', [_vm._v("Os objetivos da proposta, são compatíveis com as diretrizes do plano de trabalho firmado no âmbito de parcerias estratégicas (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_indicadores_objetivo_estrategico),
      expression: "relatorioAnalise.ds_indicadores_objetivo_estrategico"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_indicadores_objetivo_estrategico"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_indicadores_objetivo_estrategico", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivo Geral")]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Objetivo Geral do Projeto",
      "name": "objetivo Geral",
      "rows": "4",
      "disabled": true
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_objetivo_geral),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_objetivo_geral", $$v)
      },
      expression: "proposta.ds_objetivo_geral"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivos Específicos e Metas")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.objetivos), function(objetivo) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "2px solid silver !important"
      }
    }, [_vm._v(_vm._s(objetivo.ds_descricao))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-bottom": "2px solid silver !important"
      }
    }, [_c('table', _vm._l((_vm._.filter(_vm.proposta.metas, function(m) {
      return _vm._.includes(_vm._.map(m.objetivos, 'ds_descricao'), objetivo.ds_descricao)
    })), function(meta) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "border": "none",
          "border-bottom": "1px solid silver"
        }
      }, [_vm._v(_vm._s(meta.ds_descricao))])])
    }), 0)])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Indicadores de Resultado")]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Indicadores",
      "name": "indicadores",
      "rows": "4",
      "disabled": true
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_indicadores_resultado),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_indicadores_resultado", $$v)
      },
      expression: "proposta.ds_indicadores_resultado"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_indicadores_resultado)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Divulgação do projeto")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [(_vm._.includes([1, 2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Os recursos para realização das ações contidas no Plano de Comunicação foram previstos na memoria de cálculo?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_acoes_comunicacao_memoria_calculo),
      expression: "relatorioAnalise.ds_acoes_comunicacao_memoria_calculo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_divulgacao_identificacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_acoes_comunicacao_memoria_calculo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foi previsto no projeto o uso de banner obrigatório indicativo do apoio da Fundação ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_divulgacao_banner),
      expression: "relatorioAnalise.ds_divulgacao_banner"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_divulgacao_banner"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_banner", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foi prevista a identificação de veículos a serem adquiridos com recursos financeiros do projeto (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_divulgacao_identificacao),
      expression: "relatorioAnalise.ds_divulgacao_identificacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_divulgacao_identificacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_identificacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foi prevista a instalação de placa provisória e definitiva em obras civis a serem realizadas com recursos financeiros do projeto (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_divulgacao_placa),
      expression: "relatorioAnalise.ds_divulgacao_placa"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_divulgacao_placa"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_placa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foi prevista no cronograma físico a realização de atividades relativa à solenização de assinatura de convênio ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_divulgacao_solenizacao),
      expression: "relatorioAnalise.ds_divulgacao_solenizacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_divulgacao_solenizacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_divulgacao_solenizacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control ",
    attrs: {
      "data-vv-as": "Ações",
      "name": "acoes",
      "rows": "4",
      "disabled": true
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.ds_acoes_comunicacao),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "ds_acoes_comunicacao", $$v)
      },
      expression: "proposta.ds_acoes_comunicacao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_acoes_comunicacao)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Valores e contrapartida")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('th', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida + _vm.totalFBB + _vm.totalParceiro)))])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ressaltar",
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalFBB)) + "  ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar",
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalContrapartida)) + "  ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar",
    staticStyle: {
      "width": "34%"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalParceiro)) + "  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recursos da Fundação")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(10), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensFbb), function(conta) {
    return _c('tbody', [(conta.valor > 0) ? _c('tr', {
      staticClass: "conta"
    }, [_c('td', [_vm._v(_vm._s(conta.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(conta.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((conta.valor) / (_vm.totalFBB))))])]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(11), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensContrapartida), function(contra) {
    return _c('tbody', [(contra.conta) ? _c('tr', {
      staticClass: "conta"
    }, [_c('td', [_vm._v(_vm._s(contra.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.values(contra.item), function(i) {
      return i.valor
    }))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((_vm._.sumBy(_vm._.values(contra.item), function(i) {
      return i.valor
    })) / (_vm.totalContrapartida))))])]) : _vm._e()])
  })], 2)]), _vm._v(" "), (_vm.totalParceiro > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recursos de Parcerias")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.relatorioAnalise.itensParceiro), function(conta) {
    return _c('tbody', [(conta.valor > 0) ? _c('tr', {
      staticClass: "conta"
    }, [_c('td', [_vm._v(_vm._s(conta.conta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(conta.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")((conta.valor) / (_vm.totalParceiro))))])]) : _vm._e()])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Os itens de despesa propostos são compatíveis com os objetivos, metas e atividades do projeto ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_valores_itens),
      expression: "relatorioAnalise.ds_valores_itens"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_valores_itens"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_valores_itens", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A contrapartida proposta atende aos critérios específicos definidos para projetos abaixo de R$ 100 mil?' :
    'A contrapartida proposta atende aos critérios definidos nos normativos vigentes?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_valores_contrapartida),
      expression: "relatorioAnalise.ds_valores_contrapartida"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_valores_contrapartida"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_valores_contrapartida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), (!_vm.ehPIS && !_vm._.includes([2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'Os valores apresentados na memória de cálculo estão de acordo com os preços praticados no mercado ou com os parâmetros operacionais estabelecidos pela FBB?' :
    'Os valores orçados na proposta, inclusive contrapartida, estão de acordo com os praticados no mercado, conforme orçamentos apresentados ?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_valores_deacordo),
      expression: "relatorioAnalise.ds_valores_deacordo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_valores_deacordo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_valores_deacordo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Os itens de despesa, cujos orçamentos não foram apresentados, enquandram-se nas diretrizes de dispensa ou nos parâmetros estabelecidos pela Fundação ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_valores_enquadrados),
      expression: "relatorioAnalise.ds_valores_enquadrados"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_valores_enquadrados"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_valores_enquadrados", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observadas as vedações de itens de despesa, conforme norma vigente ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_valores_vedacoes),
      expression: "relatorioAnalise.ds_valores_vedacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_valores_vedacoes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_valores_vedacoes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observados os itens necessários para propostas que envolvam obra civil e/ou aquisição de bens fixos de uso industrial ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_valores_industrial),
      expression: "relatorioAnalise.ds_valores_industrial"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_valores_industrial"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_valores_industrial", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm._.includes([2], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_c('td', [_vm._v("Foram observados os itens necessários para propostas que envolvam ações de formação, capacitação e/ou consultorias ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_valores_formacao),
      expression: "relatorioAnalise.ds_valores_formacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_valores_formacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_valores_formacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.ehPIS) ? _c('tr', [_c('td', [_vm._v("Foi verificado conformidade específica para obra civil?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.conforme_obra_civil),
      expression: "relatorioAnalise.conforme_obra_civil"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "conforme_obra_civil"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "conforme_obra_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Foi realizado algum ajuste nos valores apresentados ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_valores_ajustes),
      expression: "relatorioAnalise.ds_valores_ajustes"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_valores_ajustes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_valores_ajustes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control ressaltar juntos",
    attrs: {
      "placeholder": "Descreva a seguir as observações e ajustes realizados nos valores, bem como demais justificativas pertinentes.",
      "name": "ds_valores_observacoes"
    },
    model: {
      value: (_vm.relatorioAnalise.ds_valores_observacoes),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_valores_observacoes", $$v)
      },
      expression: "relatorioAnalise.ds_valores_observacoes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_valores_observacoes)
    }
  })]), _vm._v(" "), (!_vm.ehVoluntariado) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Liberação de recursos")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Os parâmetros para concessão da modalidade de adiantamento de recursos foram atendidos conforme normativos vigentes ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_liberacao_adiantamentos),
      expression: "relatorioAnalise.ds_liberacao_adiantamentos"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_liberacao_adiantamentos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_liberacao_adiantamentos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control ressaltar juntos",
    attrs: {
      "placeholder": "Descreva a seguir, se for o caso, justificativa pela concessão de adiantamento.",
      "name": "ds_liberacao_observacoes"
    },
    model: {
      value: (_vm.relatorioAnalise.ds_liberacao_observacoes),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_liberacao_observacoes", $$v)
      },
      expression: "relatorioAnalise.ds_liberacao_observacoes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_liberacao_observacoes)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.proposta.adiantamentos) ? _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', [_vm._l((_vm.proposta.adiantamentos), function(adiantamento) {
    return _c('tr', [_c('td', {
      staticClass: "text-center w20"
    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
      staticClass: "text-center w40"
    }, [(adiantamento.origem === 1) ? _c('span', [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (adiantamento.origem === 5) ? _c('span', [_vm._v("Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center w40"
    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor)))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "ressaltar",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total adiantável")]), _vm._v(" "), _c('td', {
    staticClass: "text-center ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm.proposta.adiantamentos, function(p) {
    return p.valor
  }))) + "   (" + _vm._s(_vm._f("percentage")(((_vm._.sumBy(_vm.proposta.adiantamentos, function(p) {
    return p.valor
  })) / (_vm.totalFBB + _vm.totalParceiro)))) + ")")])])], 2), _vm._v(" "), (((_vm.proposta.adiantamentos && _vm.proposta.adiantamentos.length === 0) || (!_vm.proposta.adiantamentos))) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "100%"
    }
  }, [_vm._v("Nenhuma parcela de adiantamento cadastrada.")])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Prazo de execução e periodicidade de relatórios")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Há compatibilidade entre o prazo de execução indicado na proposta e as atividades a serem realizadas ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_execucao_compatibilidade),
      expression: "relatorioAnalise.ds_execucao_compatibilidade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_execucao_compatibilidade"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_execucao_compatibilidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual o prazo de execução do projeto ?\n                        ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_execucao_prazo),
      expression: "relatorioAnalise.ds_execucao_prazo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_titulo",
      "disabled": true,
      "id": "ds_execucao_prazo",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.relatorioAnalise.ds_execucao_prazo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.relatorioAnalise, "ds_execucao_prazo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual o prazo de vigência do projeto?")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.periodo_vigencia),
      expression: "proposta.periodo_vigencia"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_titulo",
      "disabled": true,
      "id": "prazo_vigencia",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.proposta.periodo_vigencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Qual a periodicidade dos relatórios de execução ?\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "145px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_execucao_relatorios),
      expression: "relatorioAnalise.ds_execucao_relatorios"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_execucao_relatorios",
      "id": "ds_execucao_relatorios",
      "type": "text",
      "maxlength": "255",
      "disabled": true
    },
    domProps: {
      "value": (_vm.relatorioAnalise.ds_execucao_relatorios)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.relatorioAnalise, "ds_execucao_relatorios", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control ressaltar juntos",
    attrs: {
      "placeholder": "Informe observações relevantes referente ao prazo de execução do projeto.",
      "name": "ds_execucao_observacoes"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_execucao_observacoes),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_execucao_observacoes", $$v)
      },
      expression: "relatorioAnalise.ds_execucao_observacoes"
    }
  })], 1), _vm._v(" "), (!_vm.ehVoluntariado) ? _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_execucao_observacoes)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Regularidade da proposta e da proponente")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("A proposta é compatível com os objetivos estatutários e regimentais da entidade proponente?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_regularidade_objetivos),
      expression: "relatorioAnalise.ds_regularidade_objetivos"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_regularidade_objetivos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_objetivos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A proponente apresentou toda a documentação exigida para a análise de projetos abaixo de R$ 100 mil?' :
    'A proponente apresentou toda a documentação exigida para a análise de projetos?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_regularidade_documentação),
      expression: "relatorioAnalise.ds_regularidade_documentação"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_regularidade_documentação"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_documentação", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'A proponente encontra-se em regularidade cadastral, de acordo com as exigências específicas para projetos abaixo de R$ 100 mil?' :
    'A proponente encontra-se em regularidade cadastral?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_regularidade_cadastral),
      expression: "relatorioAnalise.ds_regularidade_cadastral"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_regularidade_cadastral"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_cadastral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), (_vm._.includes([2, 3], _vm.faixaDoProjeto.faixa) && !_vm.ehPIS) ? _c('tr', [_c('td', [_vm._v("A proponente encontra-se em conformidade (fiscal e documental) e relação a exigências específicas no âmbito de parceria estratégica (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_regularidade_fiscal),
      expression: "relatorioAnalise.ds_regularidade_fiscal"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_regularidade_fiscal"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_fiscal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("A proponente já executou projetos com a FBB ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_regularidade_projetos),
      expression: "relatorioAnalise.ds_regularidade_projetos"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_regularidade_projetos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_projetos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("A proponente encontra-se em regularidades junto à FBB (inexistência de ocorrências impeditivas) ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_regularidade_ocorrencias),
      expression: "relatorioAnalise.ds_regularidade_ocorrencias"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_regularidade_ocorrencias"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_ocorrencias", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), (_vm._.includes([3], _vm.faixaDoProjeto.faixa)) ? _c('tr', [_vm._m(14), _vm._v(" "), (_vm.relatorioAnalise.ds_regularidade_rating) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_regularidade_rating.ds_descricao),
      expression: "relatorioAnalise.ds_regularidade_rating.ds_descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_titulo",
      "id": "ds_regularidade_rating",
      "type": "text",
      "maxlength": "255",
      "disabled": true
    },
    domProps: {
      "value": (_vm.relatorioAnalise.ds_regularidade_rating.ds_descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.relatorioAnalise.ds_regularidade_rating, "ds_descricao", $event.target.value)
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(15), _vm._v(" "), (_vm._.includes([1, 2], _vm.faixaDoProjeto.faixa)) ? _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.somenteLeitura,
      "type": "text",
      "maxlength": "255",
      "disabled": true
    },
    domProps: {
      "value": "C"
    }
  })]) : _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.somenteLeitura,
      "type": "text",
      "maxlength": "255",
      "disabled": true
    },
    domProps: {
      "value": !_vm.riscoCalculado ? 'Risco ainda não calculado' : _vm.riscoCalculado
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control ressaltar juntos",
    attrs: {
      "placeholder": "Descreva a seguir possíveis comentários acerca da regularidade da proposta, proponente e condicionantes, se for o caso.",
      "name": "ds_regularidade_observacoes"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_regularidade_observacoes),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_regularidade_observacoes", $$v)
      },
      expression: "relatorioAnalise.ds_regularidade_observacoes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_regularidade_observacoes)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Licenciamento ambiental")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("As atividades propostas para o projeto são passíveis de dispensa, ou licenciamento ambiental (conforme Anexo I da Resolução CONAMA n° 237 - IN-BB 671) ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_licenciamento_conforme),
      expression: "relatorioAnalise.ds_licenciamento_conforme"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_licenciamento_conforme"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_conforme", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qual documentação foi apresentada (se for o caso) ?")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_licenciamento_documentacao),
      expression: "relatorioAnalise.ds_licenciamento_documentacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_titulo",
      "id": "ds_licenciamento_documentacao",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.relatorioAnalise.ds_licenciamento_documentacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_documentacao", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control ressaltar juntos",
    attrs: {
      "placeholder": "Descreva qual a documentação apresentada, inexigibilidade ou dispensa, conforme o caso.",
      "name": "ds_licenciamento_observacoes"
    },
    model: {
      value: (_vm.relatorioAnalise.ds_licenciamento_observacoes),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_licenciamento_observacoes", $$v)
      },
      expression: "relatorioAnalise.ds_licenciamento_observacoes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_licenciamento_observacoes)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Enquadramento e Parecer jurídico")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("A proposta foi enquadrada no controle orçamentário da FBB ?")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_enquadramento_orcamento),
      expression: "relatorioAnalise.ds_enquadramento_orcamento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_enquadramento_orcamento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_orcamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Número da FEP?\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm._.has(_vm.proposta, 'fep') && _vm._.has(_vm.proposta.fep, 'numero') && _vm._.has(_vm.proposta.fep, 'ano')) ? _c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "name": "ds_enquadramento_fep",
      "id": "ds_enquadramento_fep"
    }
  }, [_vm._v(_vm._s(_vm.proposta.fep.ano + "/" + _vm.proposta.fep.numero))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(_vm.faixaDoProjeto.faixa === 1 ? 'Foi utilizada a minuta padrão aprovada para projetos abaixo de R$ 100 mil?' :
    'Foi utilizada a minuta padrão aprovada que contemple as necessidades do projeto ?') + "\n                        ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorioAnalise.ds_enquadramento_minuta),
      expression: "relatorioAnalise.ds_enquadramento_minuta"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ds_enquadramento_minuta"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_minuta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoes), function(opcao) {
    return _c('option', {
      domProps: {
        "value": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control ressaltar juntos",
    attrs: {
      "placeholder": "Informe o embasamento jurídico, parecer e/ou minuta padrão utilizados para amparo legal da minuta de convênio.",
      "name": "ds_enquadramento_observacoes"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_enquadramento_observacoes),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_enquadramento_observacoes", $$v)
      },
      expression: "relatorioAnalise.ds_enquadramento_observacoes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_enquadramento_observacoes)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivos de Desenvolvimento Sustentável (ODS)")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [(_vm.odsCadastrado.length > 0) ? _c('div', {
    staticClass: "column all-start gap-5 container-padding"
  }, _vm._l((_vm.odsCadastrado), function(ods) {
    return _c('div', [_vm._v("\n                            " + _vm._s(ods.descricao) + "\n                            "), _vm._l((ods.metasDescricao), function(meta) {
      return _c('div', [_c('i', [_vm._v("Meta " + _vm._s(meta.descricao))])])
    })], 2)
  }), 0) : _c('div', {
    staticClass: "column all-start gap-5 container-padding"
  }, [_vm._v("\n                          Não Possui ODS cadastrado.\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tecnologia Social")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [(_vm.possuiTecnologiaSocial) ? _c('div', {
    staticClass: "column all-start gap-5 container-padding"
  }, _vm._l((_vm.tecnologiasCadastradas), function(tecnologia) {
    return _c('div', [_vm._v("\n                          " + _vm._s(tecnologia.nome) + "\n                        ")])
  }), 0) : _c('div', {
    staticClass: "column all-start gap-5 container-padding"
  }, [_vm._v("\n                        Não possui Tecnologias cadastradas.\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Público-Alvo Previsto")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [(_vm.publicoAlvoDefinicoes.length > 0) ? _c('div', {
    staticClass: "column  all-start gap-5 container-padding"
  }, _vm._l((_vm.publicoAlvoDefinicoes), function(definicao) {
    return _c('div', [_vm._v("\n                           - " + _vm._s(definicao) + "\n                        ")])
  }), 0) : _c('div', {
    staticClass: "column all-start gap-5 container-padding"
  }, [_vm._v("\n                        Não possui Público-Alvo Previsto cadastrado.\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Avaliação do Projeto")]), _vm._v(" "), (_vm.questoesAvaliacao.length > 0) ? _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('div', {
    staticClass: "column all-start gap-5 container-padding"
  }, [_c('b', [_vm._v(_vm._s(_vm.questoesAvaliacao[0].resposta))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(16), _vm._v(" "), _c('tbody', _vm._l((_vm.questoesAvaliacao), function(questao, index) {
    return (index > 0) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(questao.questao || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(questao.resposta))])]) : _vm._e()
  }), 0)])]) : _c('div', {
    staticClass: "column all-start gap-5 container-padding"
  }, [_vm._v("\n                      -\n                    ")])]), _vm._v(" "), (_vm.ehPIS || _vm.ehVoluntariado) ? _c('div', {
    staticClass: "box-body juntos"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Considerações finais")]), _vm._v(" "), _c('table', {
    staticClass: "bloco"
  }, [_c('tr', [_c('td', [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "name": "ds_consideracoes_finais"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_consideracoes_finais),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_consideracoes_finais", $$v)
      },
      expression: "relatorioAnalise.ds_consideracoes_finais"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_consideracoes_finais)
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "juntos"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(17), _vm._v(" "), _c('table', {
    staticClass: "bloco"
  }, [_c('tr', [_c('td', [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "name": "ds_parecer"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_parecer),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_parecer", $$v)
      },
      expression: "relatorioAnalise.ds_parecer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_parecer)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(_vm.ehVoluntariado) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Despacho dos Gerentes de Divisão")]) : _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Despacho do " + _vm._s(_vm.faixaDoProjeto.alcada))])]), _vm._v(" "), _c('table', {
    staticClass: "bloco"
  }, [_c('tr', [_c('td', [_c('div', {
    staticClass: "nao_imprimir"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "name": "ds_despacho_observacoes"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.relatorioAnalise.ds_despacho_observacoes),
      callback: function($$v) {
        _vm.$set(_vm.relatorioAnalise, "ds_despacho_observacoes", $$v)
      },
      expression: "relatorioAnalise.ds_despacho_observacoes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "imprimir bloco_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.relatorioAnalise.ds_despacho_observacoes)
    }
  })])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Sair")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger dropdown-toggle btn-sm",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "w30"
  }, [_c('img', {
    staticClass: "logo_relatorio",
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "w10"
  }, [_c('b', [_vm._v("N° Projeto")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Nome")])]), _vm._v(" "), _c('td', {
    staticClass: "situacao_projeto w20"
  }, [_c('b', [_vm._v("Situação do Projeto")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Fundação")]), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Contrapartida*")]), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Parcerias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "w30"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%",
      "text-align": "center"
    }
  }, [_vm._v("Cargo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%",
      "text-align": "center"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "w30 text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Mandato")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Público-alvo")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho w20"
  }, [_vm._v("Participantes Diretos")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho w20"
  }, [_vm._v("Jovens")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho w20"
  }, [_vm._v("Mulheres")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "w30"
  }, [_vm._v("Objetivos Específicos")]), _vm._v(" "), _c('th', [_vm._v("Metas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Fundação")]), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Contrapartida")]), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Parcerias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
    staticClass: "text-center w20"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "text-center w10"
  }, [_vm._v("% Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
    staticClass: "text-center w20"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "text-center w10"
  }, [_vm._v("% Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Conta Financeira")]), _vm._v(" "), _c('th', {
    staticClass: "text-center w20"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "text-center w10"
  }, [_vm._v("% Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Parcela")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Origem")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Valor")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Rating calculado para a proponente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Risco Calculado do Projeto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Questão")]), _vm._v(" "), _c('th', [_vm._v("Resposta")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Proposta")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e9a63902!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/relatorioAnalise.vue
// module id = 2013
// module chunks = 2